// src/api/qiniu.js
import request from '@/utils/request'; // 导入配置好的 Axios 实例

/**
 * 从你的后端获取七牛云上传 Token
 * @returns {Promise<object>} 返回包含 token 等信息的 Promise (假设返回 res.data)
 */
export const getQiniuToken = async () => {
  try {
    const response = await request({
      url: '/qiniu/upload-token', // 确认这是你后端获取 token 的正确路径
      method: 'get',
    });
    // 根据你后端实际返回的结构调整
    // 假设 token 在 response.data 中
    if (response && response.data) {
       console.log("response.data:", response.data)
      return response.data; // 返回 token 数据
    } else {
      throw new Error('未能从后端获取有效的七牛云Token结构');
    }
  } catch (error) {
    // request 拦截器已经处理了基础错误提示，这里可以只 log 或 re-throw
    console.error('获取七牛云Token API调用失败:', error);
    throw new Error(`获取上传凭证失败: ${error.message || '未知错误'}`);
  }
};